import React from "react";
import Hamburger from "./Hamburger";
import Logo from "./Logo";
import Notification from "./Notification";
import UserInfo from "./UserInfo";

class TopHeader extends React.Component {
  render() {
    const { subHeaderTitle, user } = this.props;
    const headerColor = user?.customizedDashboard?.[0]?.header_color ?? '';
    const secondaryHeaderColor = user?.customizedDashboard?.[0]?.secondary_header_color ?? '';
    const defaultStartColor = '#087ab6';
    const defaultEndColor = '#00d39e';
    const defaultGradient = 'linear-gradient(to right, ' + defaultStartColor + ',' + defaultEndColor + ')';

    const hasCustomHeaderPair = headerColor !== '' && secondaryHeaderColor !== '';
    const color = hasCustomHeaderPair
      ? 'linear-gradient(to right, ' + headerColor + ',' + secondaryHeaderColor + ')'
      : '';
    const colorLinear = color || defaultGradient;
    const textColor = hasCustomHeaderPair ? '#fff !important' : '#159bd5 !important';
    const accentForModal =
      String(headerColor || '').trim() ||
      String(secondaryHeaderColor || '').trim() ||
      defaultStartColor;

    return (
      <div
        id="kt_header"
        className="kt-header  kt-header--fixed"
        data-kth
        eader-minimize="on"
      >
        <div className="kt-container kt-container--fluid yr-top-header"
          style={{ background: colorLinear }}>
          <Hamburger
            pageTitle={subHeaderTitle ? subHeaderTitle : ""}
            user={user}
          />
          <Logo user={user} width="100px" />
          <div className="kt-header__topbar kt-grid__item">
            <Notification user={user} />
            <UserInfo user={user} from={"web"} />
          </div>
        </div>
        <style>
          {'.outbound-voice-customer-details-modal{--ov-cd-brand:' + accentForModal + ' !important;}'}
          {'.linear-gradient{ background: ' + colorLinear + ' !important; color: #fff !important;}'}
          {'.linear-gradient-diff{ background: ' + color + ' !important; color:' + textColor + ';}'}
          {'.table-list-bg > li > a:hover { color:#fff !important;}'}
          {'.linear-gradient-a > a { background: ' + color + ' !important;}'}
          {'.linear-gradient-a-color > a { color: ' + user.customizedDashboard[0].sidebar_icon_color + ' !important;}'}
          {'.kt-menu__link > span { color: ' + user.customizedDashboard[0].sidebar_icon_color + ' !important;}'}
          {'.kt-menu__link > span:hover { color: ' + user.customizedDashboard[0].sidebar_icon_color + ' !important;}'}
          {'.linear-gradient-cancel { background: ' + color + '!important;'}

        </style>
      </div>


    );


  }
}

export default TopHeader;
